import { Fragment, Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import withComponentName from '../../../../../../../decorators/withComponentName';
import Tooltip from '../../../../../../Tooltip';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export class PricingPlansCardContent extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderColumn(list) {
    const { width } = this.props;
    return (
      <div className={cx('content__column--list')}>
        {list.map((
          {
            type,
            text,
            withQuestionMark,
            textQuestionMark,
            linkQuestionMark,
            comingSoon,
          },
        ) => (
          <Fragment key={`${type}+${text}`}>
            {comingSoon && (
              <span className={cx('coming-soon')}>coming soon</span>
            )}
            <span
              className={cx('list-item', {
                'i-item': type === 'i',
                'with-questhion__help': withQuestionMark || textQuestionMark,
              })}
            >
              <p
                /* eslint-disable react/no-danger */
                dangerouslySetInnerHTML={{ __html: text }}
                key={`${type}+${text}`}
              />
              {withQuestionMark && (
                <Tooltip
                  className={cx('question__help')}
                  isBigScreen={width >= 2800}
                >
                  This plan cannot be used to generate revenue directly or indirectly.
                  {' '}
                  <a href="https://help.cityfalcon.com/hc/en-us/articles/360033692854-non-commercial-use" target="_blank" rel="noopener noreferrer">See details.</a>
                </Tooltip>
              )}
              {textQuestionMark && (
                <Tooltip
                  className={cx('question__help')}
                  isBigScreen={width >= 2800}
                >
                  {textQuestionMark}
                  &nbsp;
                  {linkQuestionMark && (
                    <a href={linkQuestionMark} rel="noreferrer" target="_blank">Learn more.</a>
                  )}
                </Tooltip>
              )}
            </span>
          </Fragment>
        ))}
      </div>
    );
  }

  render() {
    const {
      content,
      hideForMobile,
    } = this.props;

    return (
      <div className={cx('PricingPlansCard__content', {
        'hidden-mobile': hideForMobile,
      })}
      >
        <div className={cx('content__data')}>
          {content.map(({ title, body }) => (
            <div className={cx('content__column')} key={title}>
              <span className={cx('content__column--title')}>{title}</span>
              {this.renderColumn(body)}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

PricingPlansCardContent.defaultProps = {
  hideForMobile: false,
};

PricingPlansCardContent.propTypes = {
  content: PropTypes.instanceOf(Array).isRequired,
  hideForMobile: PropTypes.bool,
};

const mapStateToProps = ({ common, promobar }) => ({
  width: common.width,
  promobarHeight: promobar.height,
});

export default connect(mapStateToProps)(withComponentName(PricingPlansCardContent));
